import React from 'react';
import { Layers } from '@lifeomic/chromicons';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { useTemplatingItemTypeDisplay } from '../../hooks';
import { theme } from '../../../../theme/phc';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(1),
  },
}));

const CompositeReportDefinitionIcon: React.FC = () => {
  const styles = useStyles();
  const templatingItemTypeDisplay = useTemplatingItemTypeDisplay();

  return (
    <span
      className={styles.icon}
      role="img"
      aria-label={templatingItemTypeDisplay.compositeReportDefinition}
    >
      <Layers width={20} height={20} color={theme.palette.primary.main} />
    </span>
  );
};

export { CompositeReportDefinitionIcon };
